import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import Layout from './containers/Layout';
import GranDia from './containers/GranDia';
import Galeria from './containers/Galeria';
import Boda from './containers/Boda';
import Regalos from './containers/Regalos';
import Asistencia from './containers/Asistencia';
import ScrollButton from './components/Utils/ScrollButton';
import Footer from './components/Footer/Footer';
import './App.css'
import Vestimenta from './containers/Vestimenta';
import Mensaje from './containers/Mensaje';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: '100%',
    width: '100%',
    backgroundColor: '#e2e1e1',
  },
}));

export default function App() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Layout />
      <Mensaje />
      <GranDia />
      <Galeria />
      <Boda />
      <Vestimenta />
      <Regalos />
      <Asistencia />
      <Footer />
      <ScrollButton />
    </div>
  );
}
